export const events = {
  ui: {
    SEARCH: "UI / Search",
    RESULT_CLICK: "UI / Result Click",
  },
};

export const EMAIL_BLOCKLIST = ["qawolf.email"];
